module.exports = __webpack_public_path__ + "static/dispos2-0660486c33e4dcffc3d36a0744dfc6c4.png";